// You can write more code here

/* START OF COMPILED CODE */

import Obstacle from "./Obstacle";
/* START-USER-IMPORTS */
import { BodyTypes } from '../../LevelManager';
import { ObstacleEffectController } from '../../ObstacleEffectController';
import { SplatEffectsLayer } from '../../../SplatEffectsLayer';
import { app } from '../../../core/App';
/* END-USER-IMPORTS */

export default class ObstacleOilSlick extends Obstacle {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 100.5, y ?? 29, texture || "game", frame ?? "obstacle-oil-slick.png");

    // this (prefab fields)
    this.slowStrength = 0.5;
    this.hitEffect = "slide";

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  public init() {
    (this.body as MatterJS.BodyType).label = BodyTypes.Obstacle;

    super.init();
  }

  public onHit(wasPlayer: boolean, isSingleUse: boolean, hitPointX: number, delay: number) {
    if(!this.hasBeenHit){
      app.audioHandler.playSound(this.scene, 'SndObstacleSplash2', 'sfx');
    }
    this.scene.events.emit(ObstacleEffectController.events.ShowEffect, this, hitPointX, this.y);

    if (wasPlayer) {
      this.scene.events.emit(SplatEffectsLayer.events.SplatOil, hitPointX - this.scene.cameras.main.scrollX, this.y - this.scene.cameras.main.scrollY, 5);
    }

    super.onHit(wasPlayer, false, hitPointX, 500);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
